import React, { useEffect, useRef, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import TopFilter from '../components/TopFilter';
import RightFilterToggle from '../components/RightFilterToggle';
import paginationFactory from 'react-bootstrap-table2-paginator';
import GridData from '../components/gridmodal/GridDataPackages';
// import { propTypes } from 'react-bootstrap/esm/Image';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
// import PriceFilter from '../components/CustomGridFilter';
import configData from '../configData.json';
import { format } from 'date-fns';
import Spinner from 'react-bootstrap/Spinner';
import ColumnFilter from '../components/ColumnFilter';
import { Link } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import LeftMenu from '../components/LeftMenu';
import ForecastRightFilterToggle from '../components/ForecastRightFilterToggle';
import MycustomDesignGrid from '../components/MycustomDesignGrid';

export default function InvoiceVolumeForecast() {

    const [ProcessedBills, setProcessedBills] = useState([]);
    const [InvVolForecast, setInvVolForecast] = useState([]);
    const [DetailByCustCarr, setDetailData] = useState([]);
    const [selectedSummaryRow, setSelectedRow] = useState({});
    const [lastElement, setLastElement] = useState(null);
    const [hidden, setHidden] = useState(true);
    const [fbNum, setFbNum] = useState("");
    const [acctNo, setAcctNo] = useState("");

    const [custKey, setCustomerKey] = useState(0);
    const [carrKey, setCarrierKey] = useState(0);

    const [pstNumOfWk, setPstNumOfWk] = useState(0);
    const [imPstNumWk, setImPstNumWk] = useState(0);
    const [perDecrease, setPerDecrease] = useState(0);
    const [perIncrease, setPerIncrease] = useState(0);

    const { ExportCSVButton } = CSVExport;
    const { ExportCSVButtonDetail } = CSVExport;

    const [fromDate, setFromDate] = useState(undefined);
    const [toDate, setToDate] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [fbLoading, setFBLoading] = useState(false);
    const [prevY, setPrevY] = useState(0);

    let prevYRef = useRef({});
    let selectedRowRef = useRef({});
    let DetailByCustCarrRef = useRef({});
    let hiddenRef = useRef({});
    let pageRef = useRef({});

    prevYRef.current = prevY;
    selectedRowRef.current = selectedSummaryRow;
    DetailByCustCarrRef.current = DetailByCustCarr;
    hiddenRef.current = hidden;
    pageRef.current = page;

    const criData = [
        { criKey: 1, criValue: 'Owner' },
        { criKey: 2, criValue: 'Customer' },
        // { criKey: 2, criValue: 'Transportation Provider' },
        // { criKey: 3, criValue: 'Freight Bill Number' },
        // { criKey: 4, criValue: 'Transportation Provider Account Number' }
        { criKey: 6, criValue: 'Division' },
    ];


    const searchOnClick = (customerKey, pastNumOfWeek, immediatePastNumWeek, percentageDecrease, percentageIncrease, divisionKey) => {

        // debugger;
        setCustomerKey(customerKey);
        setPstNumOfWk(pastNumOfWeek);
        setImPstNumWk(immediatePastNumWeek);
        setPerDecrease(percentageDecrease);
        setPerIncrease(percentageIncrease);
        LoadSummaryData(customerKey, pastNumOfWeek, immediatePastNumWeek, percentageDecrease, percentageIncrease, divisionKey);
    }

    const LoadSummaryData = async (customerKey, pastNumOfWeek, immediatePastNumWeek, percentageDecrease, percentageIncrease, divisionKey) => {
        // debugger;
        setLoading(true);
        setInvVolForecast([]);
        const URL = `${configData.BASE_APP_URL}FreightBill/GetInvoiceVolumeForecast/${customerKey}/${pastNumOfWeek}/${immediatePastNumWeek}/${percentageDecrease}/${percentageIncrease}/${divisionKey}`;
        console.log(URL);
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setInvVolForecast(resp));
        setLoading(false);
    }

    const DownloadSummaryData = async () => {

        const URL = `${configData.BASE_APP_URL}FreightBill/GenerateExcelForInvoiceVolumeForecast`;
        console.log(URL);

        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: InvVolForecast }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `Invoice Forecast By Customer and Provider.xlsx`;
        link.click();

    };

    const onTopBillsSelect = (e) => {
        // debugger;
        // onchange="this.nextElementSibling.value=this.value"
        const topBills = document.getElementById("topbills").value;
        const fbNumber = fbNum === "" ? "-1" : fbNum;
        const acctNumber = acctNo === "" ? "-1" : acctNo;
        LoadSummaryData(custKey, carrKey, fromDate, toDate, fbNumber, acctNumber, topBills);
    };

    const LoadDetailData = async (customerKey, carrierKey, billType, setLoadingFunc, fromDetails) => {
        setLoadingFunc(true);
        const fbNumber = fbNum === "" ? "-1" : fbNum;
        const acctNumber = acctNo === "" ? "-1" : acctNo;

        const URL = `${configData.BASE_APP_URL}FreightBill/GetProcessedInvoiceDetailByPage/${customerKey}/${carrierKey}/${billType}/${fromDate}/${toDate}/${pageRef.current}/${fbNumber}/${acctNumber}/${configData.PAGE_SIZE}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                setDetailData([...DetailByCustCarrRef.current, ...resp]);
                //OpenPopup();
                setHidden(false);
            })
        setLoadingFunc(false);
    }

    const NumberFormatter = (cell, row, rowIndex, formatExtraData) => {
        let isTotal = false;
        if (row.billType === 'TOTAL') {
            isTotal = true
        }

        return (
            isTotal == true
                ? <span><b>{cell.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</b></span>
                : <span>{cell.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
        );
    }

    const AmountFormatter = (cell, row, rowIndex, formatExtraData) => {
        let isTotal = false;
        if (row.billType === 'TOTAL') {
            isTotal = true
        }
        return (
            isTotal == true
                ? <span><b><span>{parseFloat(cell).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></b></span>
                : <span><span>{parseFloat(cell).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></span>

        )
    }

    // const AmountFormatterCsv = (cell) => {
    //     return `"${cell.toFixed(2)}"`;
    // }

    // const columnFormatter = (cell, row, rowIndex, formatExtraData) => {
    //     return (
    //         <div>
    //             <span><a href='#'><i className="fa fa-expand mr-1"></i></a>{row.customerName}</span>
    //         </div>
    //     )
    // }


    const freightBillFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=" + '"' + cell + '"'
        )
    }


    const invoiceDateFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <span>{format(new Date(cell), "MM/dd/yyyy")}</span>
        )
    }

    const invoiceDateFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        let newDate = format(new Date(cell), "MM/dd/yyyy");
        return (
            "=SUBSTITUTE(" + '"' + newDate + '"' + "," + '"' + "-" + '"' + "," + '"' + "/" + '"' + ")"
        )
    }

    const imageLinkFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <a target="_blank" href={cell}>View</a>
        )
    }

    const imageLinkFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=HYPERLINK(" + '"' + cell + '",' + '"' + "View" + '"' + ")"
        )
    }

    let onCustomerFilter;
    let onCarrierFilter;
    const onCustomerChangeFilter = (selectedCust, selectedPastNumOfWeek, selectedImmediatePastNumWeek, selectedPercentageDecrease, selectedPercentageIncrease, selectedDivision) => {
        // debugger;
        setCustomerKey(selectedCust);
        LoadSummaryData(selectedCust, selectedPastNumOfWeek, selectedImmediatePastNumWeek, selectedPercentageDecrease, selectedPercentageIncrease, selectedDivision);
    };

    const onCarrierChangeFilter = (val) => {
        //onCarrierFilter(val);
        console.log(val)
    };

    const tpFormatter = (cell, row, rowIndex, formatExtraData) => {
        // console.log(row.billType);
        let isTotal = false;
        if (row.billType === 'TOTAL') {
            isTotal = true
        }

        return (
            isTotal ? <span></span> : <span>{cell}</span>
        )
    }

    const tpFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        // console.log(row.billType);
        let isTotal = false;
        if (row.billType === 'TOTAL') {
            isTotal = true
        }

        return (
            isTotal ? 'TOTAL' : cell
        )
    }

    const billtypeFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        // console.log(row.billType);
        let isTotal = false;
        if (cell === 'TOTAL') {
            isTotal = true
        }

        return (
            isTotal ? <span><b>TOTAL</b></span> : <span>{cell}</span>

        )
    }

    const columns = [
        {
            dataField: 'transportationName',
            text: 'Transportation Provider Name',
            headerStyle: { width: '250px', textAlign: 'center' },
            filter: customFilter(),
            // sort: true,
            formatter: tpFormatter,
            csvFormatter: tpFormattercsv,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'billType',
            text: 'Bill Type',
            headerStyle: { width: '80px', textAlign: 'center' },
            // filter: customFilter(),
            // sort: true,
            formatter: billtypeFormattercsv,
            csvFormatter: billtypeFormattercsv
            // filterRenderer: (onFilter, column) =>
            //     <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'weekOne',
            text: 'Week 1 most current recent week Number of Invoices',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: NumberFormatter
        },
        {
            dataField: 'weekOneDollarAmount',
            text: 'Week 1 most current recent week Dollar Amount',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter,
            csvFormatter: (cell, row, rowIndex) => `${parseFloat(cell).toFixed(2)}`
        },
        {
            dataField: 'weekTwo',
            text: 'Week 2 second most current recent week Number of Invoices',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: NumberFormatter

        },
        {
            dataField: 'weekTwoDollarAmount',
            text: 'Week 2 second most current recent week Dollar Amount',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter
        },
        {
            dataField: 'weekThree',
            text: 'Week 3 third most current recent week Number of Invoices',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: NumberFormatter

        },
        {
            dataField: 'weekThreeDollarAmount',
            text: 'Week 3 third most current recent week Dollar Amount',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter

        },
        {
            dataField: 'avgNumOfInvPastTwentyWeeks',
            text: 'Average Number Of Invoices Past 20 Weeks Per Week',
            headerStyle: { width: '135px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter

        },
        {
            dataField: 'avgNumOfInvPastThreeWeeks',
            text: 'Average Number Of Invoices Past 3 Weeks Per Week',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter

        },
        {
            dataField: 'avgAmtOfInvPastTwentyWeeks',
            text: 'Average Dollar Amount Past 20 Weeks Per Week',
            headerStyle: { width: '135px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter

        },
        {
            dataField: 'avgAmtOfInvPastThreeWeeks',
            text: 'Average Dollar Amount Past 3 Weeks Per Week',
            headerStyle: { width: '125px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter

        },
        {
            dataField: 'percentageDecrease',
            text: 'Percentage Decrease Calculated Based on Average Number of Invoices',
            headerStyle: { width: '135px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter

        },
        {
            dataField: 'percentageIncrease',
            text: 'Percentage Increase Calculated Based on Average Number of Invoices',
            headerStyle: { width: '135px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter

        },
        {
            dataField: 'percentageDecreaseDollarAmount',
            text: 'Percentage Decrease Calculated Based on Average Dollar Amount',
            headerStyle: { width: '135px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter

        },
        {
            dataField: 'percentageIncreaseDollarAmount',
            text: 'Percentage Increase Calculated Based on Average Dollar Amount',
            headerStyle: { width: '135px', textAlign: 'center' },
            align: 'right',
            sort: true,
            formatter: AmountFormatter

        }

    ];

    const pagingOptioins = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    }

    const observer = useRef(
        new IntersectionObserver((entries, pagingOptioins) => {
            const first = entries[0];
            if (first.isIntersecting) {
                setPage((no) => no + 1);
            }
        })
    );

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        if (selectedSummaryRow.customerKey) {
            LoadDetailData(selectedSummaryRow.customerKey, selectedSummaryRow.carrierKey, selectedSummaryRow.billType, setFBLoading, true)
        }
    }, [pageRef.current])

    useEffect(() => {
        const currentElement = lastElement;
        const currentObserver = observer.current;

        if (currentElement) {
            currentObserver.observe(currentElement);
        }

        return () => {
            if (currentElement) {
                currentObserver.unobserve(currentElement);
            }
        };
    }, [lastElement]);

    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                        >
                            {option.text}
                        </button>
                    );
                })
            }
        </div>
    );

    const options = {
        sizePerPageRenderer,
        sizePerPageList: [{
            text: '50', value: 50
        }, {
            text: '100', value: 100
        },
        {
            text: '200', value: 200
        }, {
            text: 'All', value: InvVolForecast.length
        }]
    };

    const breadcumTitle = <div dangerouslySetInnerHTML={{ __html: 'Invoice Forecast By Customer/Provider' }} />;

    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />
                    <div className='pt-1 px-3 pb-3 py-3'>

                        {/* <Breadcrumbs title="Invoices Processed By Character ( Top 10 Bills By Greatest Number of Character)" /> */}
                        <Breadcrumbs title={breadcumTitle} />
                        {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
                        <div className='sticky-top-content'>
                            <TopFilter oncustom={onCustomerChangeFilter} oncustom1={onCarrierChangeFilter} criData={criData} isDateDropdownHidden={true} />
                        </div>
                        <div className='d-flex'>

                            <div className="table-container">
                                <div className='grid-toggle'>
                                    <div className='main-table-text dropup'>
                                        {/* <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: "right" }}>
                                            <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export
                                            </button>
                                        </div> */}
                                        {InvVolForecast.length > 0 ?


                                            <ToolkitProvider
                                                keyField="freightBillKey"
                                                data={InvVolForecast}
                                                columns={columns}
                                                exportCSV>
                                                {
                                                    props => (
                                                        <div>
                                                            <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: "right" }}>
                                                                <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export
                                                                </button>
                                                            </div>
                                                            <BootstrapTable
                                                                classes='table table-striped table-hover table-width'
                                                                headerClasses='table-top'
                                                                bootstrap4
                                                                pagination={paginationFactory(options)}
                                                                {...props.baseProps}
                                                                filter={filterFactory()}
                                                            />
                                                            {/* <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export</button> */}
                                                            {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButton> */}
                                                        </div>
                                                    )
                                                }
                                            </ToolkitProvider> : <>
                                                <MycustomDesignGrid column={columns} />
                                            </>}
                                    </div>
                                </div>
                            </div>
                            <ForecastRightFilterToggle onSearchClick={searchOnClick} isCheckBoxHidden="true" />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}